module.exports = __webpack_public_path__ + "img/71.29761942.png";